function init() {
  document.addEventListener('DOMContentLoaded', () => {
    const setup = (input) => {
      if (input.dataset.hasEye) return;
      input.dataset.hasEye = true;

      const wrapper = document.createElement('div');
      wrapper.style.position = 'relative';
      wrapper.style.overflow = 'visible';
      input.parentNode.insertBefore(wrapper, input);
      wrapper.appendChild(input);

      // IMPORTANT : libère la place pour l’icône
      input.style.paddingRight = '32px';

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.style.position = 'absolute';
      btn.style.right = '8px';
      btn.style.top = '50%';
      btn.style.transform = 'translateY(-50%)';
      btn.style.fontSize = '14px';
      btn.style.cursor = 'pointer';
      btn.style.background = 'none';
      btn.style.border = 'none';
      btn.style.zIndex = '20'; // <-- l’icône passe au-dessus
      btn.textContent = '👁️';
      wrapper.appendChild(btn);

      btn.addEventListener('click', () => {
        input.type = input.type === 'password' ? 'text' : 'password';
        btn.textContent = input.type === 'password' ? '👁️' : '🙈';
      });
    };

    // Initialisation sur inputs existants
    document.querySelectorAll('input[type="password"]').forEach(setup);

    // Détection des inputs ajoutés dynamiquement
    new MutationObserver(() => {
      document.querySelectorAll('input[type="password"]').forEach(setup);
    }).observe(document.body, { childList: true, subtree: true });
  });
}

try {
  init();
} catch (error) {
  console.log(error);
}
